module.exports = __webpack_public_path__ + "static/media/top-teacher-icon.997a4978.svg";